import { enviroments } from '@infrastructure/enviroments';
import { base } from '@service/base';
import { PageLimitFilter } from '@typings';

import { TOrderBumpResponse } from 'src/models/OrderBump.model';

const BASE_URL = enviroments.BASE_URL;

export async function getAllOrderBumps({
  page,
  limit,
  filter,
  order: ordered,
}: PageLimitFilter): Promise<TOrderBumpResponse> {
  let where = {};
  if (filter) {
    Object.keys(filter).forEach(key => {
      if (filter[key]) {
        where = {
          ...where,
          [key]: filter[key],
        };
      }
    });
  }

  const order = !ordered || ordered === '' ? '[id,ASC]' : ordered;

  const response = await base({
    baseURL: BASE_URL,
    url: `/order-bump`,
    method: 'GET',
    params: {
      ...where,
      limit,
      page,
      order,
    },
  });

  return {
    count: response.data.total,
    rows: response.data.data,
  };
}
